import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { endOfDay, startOfDay } from "date-fns";
import {
  Icons,
  PageHeader,
  IconButton,
  Button,
  Modal,
  DateRangePicker,
} from "@pushpress/shared-components";
import { useToggle } from "../../../hooks/state";
import { useAppDispatch } from "../../../redux/store";
import { appointmentScheduleExport } from "../../../redux/actions/apppointmentThunks";
import CreditsModal from "../CreditsModal";

const helpUrl =
  "https://help.pushpress.com/en/articles/6310433-core-appointments-system-overview";

interface AppointmentHeaderProps {
  onBookClick: VoidFunction;
}

function AppointmentHeader(props: AppointmentHeaderProps) {
  const { onBookClick } = props;

  const history = useHistory();

  const dispatch = useAppDispatch();

  const [showPayrollExport, payrollExportActions] = useToggle(false);

  const [creditsVisible, creditsVisibleActions] = useToggle(false);

  const exportPayroll = useCallback(
    (dateRange: { startDate: Date; endDate: Date }) => {
      payrollExportActions.off();
      dispatch(
        appointmentScheduleExport({
          from: startOfDay(dateRange.startDate),
          to: endOfDay(dateRange.endDate),
        }),
      );
    },
    [dispatch, payrollExportActions],
  );

  return (
    <>
      <PageHeader title="Appointments">
        <PageHeader.ActionMenu>
          <IconButton
            icon={Icons.Help}
            tooltip="Learn more"
            onClick={() => {
              window.open(helpUrl, "_blank")?.focus();
            }}
          />
          <IconButton
            icon={Icons.Download}
            tooltip="Export appointments schedule (CSV)"
            onClick={payrollExportActions.on}
          />
          <IconButton
            icon={Icons.NavIconSettings}
            tooltip="Setup"
            onClick={() => {
              history.push("/appointments/settings");
            }}
          />
          <Button
            text="Add Credits"
            iconLocation="left"
            icon={Icons.Plus}
            size="large"
            buttonType="secondary"
            hideTextOnMobile
            onClick={creditsVisibleActions.on}
          />
          <Button
            text="Book Appointment"
            iconLocation="left"
            icon={Icons.Plus}
            size="large"
            hideTextOnMobile
            onClick={onBookClick}
          />
        </PageHeader.ActionMenu>
      </PageHeader>
      <Modal visible={showPayrollExport} closeModal={payrollExportActions.off}>
        <DateRangePicker
          tabs={["relative", "custom"]}
          relativeDirection="past"
          buttonText="Download"
          buttonIcon={Icons.Download}
          onSubmit={exportPayroll}
          onClose={payrollExportActions.off}
        />
      </Modal>
      <CreditsModal
        visible={creditsVisible}
        onClose={creditsVisibleActions.off}
        onSuccess={creditsVisibleActions.off}
      />
    </>
  );
}

export default AppointmentHeader;
